export const calendarData = [
  { date: 25, day: "Mon", appointments: ["10:00", "11:00", "12:00"] },
  { date: 26, day: "Tues", appointments: ["08:00", "09:00", "10:00"] },
  { date: 27, day: "Wed", appointments: ["12:00", "—", "13:00"] },
  { date: 28, day: "Thurs", appointments: ["10:00", "11:00", "—"] },
  { date: 29, day: "Fri", appointments: ["—", "14:00", "16:00"] },
  { date: 30, day: "Sat", appointments: ["12:00", "14:00", "15:00"] },
  { date: 31, day: "Sun", appointments: ["09:00", "10:00", "11:00"] },
];

